export default {"src":"/_next/static/media/phone.67e13c62.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};